import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import {useDispatch, useSelector} from "react-redux";
import {CheckModalOpen} from "../../../redux/slices/paymentSlice";
import {Fragment} from "react";
import logo from "../../../assets/images/logo.png"
import {Box} from "@mui/material";
import {PDFDownloadLink, PDFViewer} from "@react-pdf/renderer";
import {FaRegFilePdf} from "react-icons/fa6";
import CheckTemplate from "./CheckTemplate";
import {useTranslation} from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function Check({senderPhone, senderName, amount, recipientPhone, recipientName, comment, comicion, documentNumber, template}) {
    const {checkModalOpen} = useSelector((state) => state.currency);
    const dispatch = useDispatch();
    const handleClose = () => dispatch(CheckModalOpen(false));
    const date = new Date();
    const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).replace(',', '');
    const {t} = useTranslation();
    const formattedAmount = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2 }).format(amount).replace(",", ".");

    return (
        <Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={checkModalOpen}
                maxWidth="xs"
                fullWidth={true}
                style={{marginTop: "73px"}}
            >
                <DialogContent dividers sx={{display: 'flex', flexDirection: 'column'}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', paddingLeft: 3, paddingRight: 3, marginBottom: 2}}>
                        <img src={logo} alt="logo" width={100}/>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15, marginTop: 1}}>{t("Receipt of the transaction")}</Typography>
                        <Typography sx={{
                            color: "#9e9e9e",
                            fontSize: 15,
                            marginTop: 0.5,
                            borderBottom: "2px dashed #9e9e9e",
                            width: "100%",
                            textAlign: "center",
                            paddingBottom: 1
                        }}>{formattedDate}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Operation")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{t("Transfer to client TipsSi")}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Recipient name")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{recipientName}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 3, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Recipient phone")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{recipientPhone}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Sender name")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{senderName}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Sender phone")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{senderPhone}</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Amount")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{formattedAmount}€</Typography>
                    </Box>
                    <Box sx={{marginBottom: 0.5, paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Commission")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{comicion}</Typography>
                    </Box>
                    <Box sx={{paddingLeft: 3, paddingRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15}}>{t("Document Number")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{documentNumber}</Typography>
                    </Box>
                    <Box sx={{borderTop: "2px dashed #9e9e9e", marginTop: 2, marginLeft: 3, marginRight: 3}}>
                        <Typography sx={{color: "#8c8c8c", fontSize: 15, paddingTop: 1}}>{t("Additional information")}</Typography>
                        <Typography sx={{color: "#000000c7", fontSize: 18, fontWeight: 600}}>{t("If you have sent money to the wrong person,  contact the recipient of the transfer.  Only the recipient can return the money.")}</Typography>
                    </Box>
                    <Box sx={{width: "60%", margin: "50px auto 0", display: "flex", justifyContent: "center", alignItems: "center", padding: 1.5, border: "2px solid #0666eb"}}>
                        <Typography sx={{color: "#0666eb", fontSize: 20}}>{t("Operation performed")}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <PDFDownloadLink
                        document={template}
                        fileName={documentNumber + ".pdf"}
                    >
                        <Button
                            variant="contained"
                            startIcon={<FaRegFilePdf fontSize={23}/>}
                            style={{width: "100%"}}
                            className="btn"
                        >
                            {t("Download")}
                        </Button>
                    </PDFDownloadLink>
                </DialogActions>
            </BootstrapDialog>
        </Fragment>
    );
}
